module.exports = __webpack_public_path__ + "static/img/success.6a31053d.svg";